import { ZfLoadingSpinner } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import type { ChartType } from '../../config/constants';
import { useLayout } from '../../contexts/layout-context';
import { SettingBoxBase, SettingsDrawer } from '../settings-drawer';
import { AssetsWithJbSettings } from './AssetsWithJbSettings';
import { AssetWithOtherBanksSettings } from './AssetWithOtherBanksSettings';
import { MonteCarloGeneralSettings } from './general-settings/MonteCarloGeneralSettings';
import { ProjectionPeriodSlider } from './general-settings/ProjectionPeriodSlider';
import { OneOffCashflowSettings } from './OneOffCashflowSettings';
import { RecurringCashflowSettings } from './RecurringCashflowSettings';

interface IProps {
    isDrawerOpen: boolean;
    onCloseDrawer: () => void;
    chartType: ChartType;
}

export const SimulationSettingsDrawer: FunctionComponent<IProps> = ({ isDrawerOpen, onCloseDrawer, chartType }) => {
    const { t } = useTranslation();
    const { totalNavbarHeight } = useLayout();

    const isMonteCarlo = chartType === 'MONTE_CARLO_PROJECTION';

    return (
        <SettingsDrawer
            isDrawerOpen={isDrawerOpen}
            onCloseDrawer={onCloseDrawer}
            title={t('simulationSettings')}
            height={`calc(100vh - ${totalNavbarHeight}px)`}
        >
            <Suspense fallback={<ZfLoadingSpinner />}>
                <SettingBoxBase
                    title={t('generalSettings')}
                    showMainToggle={false}
                    detail={isMonteCarlo ? <MonteCarloGeneralSettings /> : <ProjectionPeriodSlider />}
                />
                {isMonteCarlo ? <AssetsWithJbSettings /> : null}
                {isMonteCarlo ? <AssetWithOtherBanksSettings /> : null}
                <RecurringCashflowSettings />
                <OneOffCashflowSettings />
            </Suspense>
        </SettingsDrawer>
    );
};
